import * as React from "react";
import {Badge} from "react-bootstrap";


const columns = (t) => [

    {
        label: t ? t("common.line") : "Linia",
        field: "name",
        sort: "desc",
        type: "badge",
        width: 53,
    },

    {
        field: "installed",
        label: t ? t("common.installed") : "Urządzono",
        sort: "desc",
        width: 10,
        type: "custom",
        custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
            return <>
                {externalState &&
                    <div className="">
                        <span className={`badge badge-primary-outline mr-1 ml-1`}>
                            <span>{externalState[row.id].installed + "/" + externalState[row.id].total}</span>
                        </span>
                    </div>

                }
            </>
        }

    },

    {
        field: "production",
        label: t ? t("menu.production") : "Produkcja",
        sort: "desc",
        width: 53,
        type: "custom",
        custom: function (column, row, history) {
            return <>
                {
                    row.production && <>
                        {
                            row.production.condition &&
                            <Badge variant={"warning"} className={"font-max mr-2"}>{t ? t("status.conditional_production") : "W trakcie warunkowej produkcji"}</Badge>
                        }
                        {
                            !row.production.condition &&
                            <Badge variant={"primary"} className={"mr-2"}>{t ? t("status.in_progress") : "W trakcie produkcji"}</Badge>
                        }
                    </>
                }
                {
                    !row.production && <>
                        <Badge variant={"dark"} className={"mr-2 font-max"}>{t ? t("common.none") : "Brak"}</Badge>
                    </>
                }


            </>
        }

    }


];

export default columns;